// Font loading optimization utility
export const loadFonts = () => {
  // Check if fonts are already loaded
  if (document.fonts && document.fonts.ready) {
    return document.fonts.ready;
  }
  
  // Fallback for older browsers
  return new Promise((resolve) => {
    const checkFonts = () => {
      if (document.fonts && document.fonts.check('16px Inter')) {
        resolve(undefined);
      } else {
        setTimeout(checkFonts, 100);
      }
    };
    checkFonts();
  });
};

// Preload critical fonts
export const preloadCriticalFonts = () => {
  const fontPreloads = [
    {
      href: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
      as: 'style',
      crossorigin: 'anonymous'
    }
  ];
  
  fontPreloads.forEach(font => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = font.href;
    link.as = font.as;
    if (font.crossorigin) {
      link.crossOrigin = font.crossorigin;
    }
    document.head.appendChild(link);
  });
};

// Font display optimization
export const optimizeFontDisplay = () => {
  // Add font-display: swap to all font faces
  const style = document.createElement('style');
  style.textContent = `
    @font-face {
      font-family: 'Inter';
      font-display: swap;
    }
    @font-face {
      font-family: 'Poppins';
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
};
